import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type UIState = {
  headerHeight: number;
  searchHeight: number;
  showResolvedComments: boolean;
  showDismissedComments: boolean;
  showDeletedComments: boolean;
  authenticationDialogOpen: boolean;
  drawerOpen: {
    app: boolean;
    comments: boolean;
  };
};

const initialState: UIState = {
  headerHeight: 0,
  searchHeight: 0,
  showResolvedComments: false,
  showDismissedComments: false,
  showDeletedComments: false,
  authenticationDialogOpen: false,
  drawerOpen: {
    app: false,
    comments: false,
  },
};

export const UISlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setHeaderHeight(state, action) {
      state.headerHeight = action.payload;
    },
    setSearchHeight(state, action) {
      state.searchHeight = action.payload;
    },
    setAuthenticationDialogOpen(state, action: PayloadAction<boolean>) {
      state.authenticationDialogOpen = action.payload;
    },
    toggleShowResolvedComments(state) {
      state.showResolvedComments = !state.showResolvedComments;
    },
    toggleShowDismissedComments(state) {
      state.showDismissedComments = !state.showDismissedComments;
    },
    toggleShowDeletedComments(state) {
      state.showDeletedComments = !state.showDeletedComments;
    },
    setDrawerOpen(
      state,
      action: PayloadAction<Partial<UIState["drawerOpen"]>>,
    ) {
      Object.assign(state.drawerOpen, action.payload);
    },
  },
});

export const {
  setHeaderHeight,
  setSearchHeight,
  setAuthenticationDialogOpen,
  toggleShowResolvedComments,
  toggleShowDismissedComments,
  toggleShowDeletedComments,
  setDrawerOpen,
} = UISlice.actions;
